import { Button } from '@mantine/core';
import { useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { useResearchPerfEvalStart } from '@/module/ResearchPerfEval/model/ResearchPerfEvalQuery';

import { Id, useAppNotification } from '@feature/utils';

interface StartResearchPerfEvalButtonProps {
  evaluationId: Id;
  alreadyStarted: boolean;
}

export function StartResearchPerfEvalButton({ evaluationId, alreadyStarted }: StartResearchPerfEvalButtonProps) {
  const notification = useAppNotification();
  const { mutate, isPending } = useResearchPerfEvalStart(evaluationId);
  const { t } = useTranslation();
  const navigate = useNavigate();

  const onClick = () => {
    mutate(undefined, {
      onSuccess: () =>
        navigate({
          to: `/research-perf-eval/$evaluationId/report/gather`,
          params: { evaluationId: String(evaluationId) },
        }),
      onError: notification.error,
    });
  };

  return (
    <Button
      loading={isPending}
      size="xs"
      onClick={onClick}
    >
      {t(alreadyStarted ? 'researchPerfEval.continueReporting' : 'researchPerfEval.startReporting')}
    </Button>
  );
}
